import Vue from 'vue';
import Vuex from 'vuex';
import api from '@/api/api.js';
import { login } from '@/services.js';
Vue.use(Vuex);

export default new Vuex.Store({
  strict: true,
  state: {
    login: false,
    usuario: {
      id: '',
      nome: '',
      email: '',
      senha: '',
      cep: '',
      rua: '',
      numero: '',
      bairro: '',
      cidade: '',
      estado: ''
    },
    usuarioProdutos: null
  },
  mutations: {
    UPDATE_LOGIN(state, payload) {
      state.login = payload;
    },
    UPDATE_USUARIO(state, payload) {
      state.usuario = Object.assign(state.usuario, payload);
    },
    UPDATE_USUARIO_PRODUTOS(state, payload) {
      state.usuarioProdutos = payload;
    },
    ADD_USUARIO_PRODUTO(state, payload) {
      state.usuarioProdutos.unshift(payload);
    }
  },
  actions: {
    getUsuarioProdutos(context) {
      return api.get(`/produto?usuario_id=${context.state.usuario.id}`)
        .then(res => context.commit('UPDATE_USUARIO_PRODUTOS', res.data));
    },
    getUsuario(context) {
      return api.get('/usuario').then(response => {
        context.commit('UPDATE_USUARIO', response.data);
        context.commit('UPDATE_LOGIN', true);
      });
    },
    addUsuario(context, payload) {
      context.commit('UPDATE_USUARIO', { id: payload.email });
      return api.post('/usuario', payload);
    },
    logarUsuario(context, payload) {
      return login({
        username: payload.email,
        password: payload.senha
      })
      .then(res => window.localStorage.token = `Bearer ${res.data.token}`);
    },
    deslogarUsuario(context) {
      context.commit('UPDATE_USUARIO', {
        id: '',
        nome: '',
        email: '',
        senha: '',
        cep: '',
        rua: '',
        numero: '',
        bairro: '',
        cidade: '',
        estado: ''
      });
      window.localStorage.removeItem('token');
      context.commit('UPDATE_LOGIN', false);
    }
  }
});